<template>
  <div>
    <el-row :gutter="12" class="mt-2" v-loading.fullscreen.lock="orders.isLoading">
      <el-row type="flex" justify="space-between" align="middle" class="mb-4">
        <p class="category-title ma-0">Order</p>

        <el-col :span="16">
          <el-row type="flex" justify="end">
            <el-select
              v-model="valueStatus"
              size="small"
              placeholder="Select"
              class="mr-2"
              @change="onFilterStatus"
              style="width: 200px"
            >
              <el-option
                v-for="item in optionsStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <el-select
              v-model="optionView"
              size="small"
              placeholder="Select"
              class="mr-2"
              @change="
            e => {
              toAnotherPage(page, e, form.search, valueStatus), settingTable(page, e);
            }
          "
              style="width: 100px"
            >
              <el-option
                v-for="item in optionsView"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <el-input
              size="small"
              v-model="form.search"
              placeholder="Search by order id or customer name"
              style="width: 200px"
              class="mr-2"
              @keyup.enter.native="onSearch"
            ></el-input>
          </el-row>
        </el-col>
      </el-row>

      <el-col :span="24">
        <el-table empty-text="Tidak ada data" :data="orders.data" style="width: 100%">
          <el-table-column sortable prop="branchCodeData" label="Branch" width="130"></el-table-column>
          <el-table-column sortable prop="orderId" label="Order ID" width="130"></el-table-column>
          <el-table-column sortable prop="status" label="Status Order" width="180">
            <template slot-scope="scope">
              <el-tag v-if="branch === 'prod'" effect="dark">
                ORDER DITERIMA
              </el-tag>
              <el-tag
                v-else-if="scope.row.status === 'payment_confirmation'"
                effect="dark"
              >Menunggu Pembayaran</el-tag>
              <el-tag
                v-else-if="scope.row.status === 'pending'"
                type="danger"
                effect="dark"
              >Tertunda</el-tag>
              <el-tag
                v-else-if="scope.row.status === 'on_progress'"
                type="info"
                effect="dark"
              >Dalam Proses</el-tag>
              <el-tag
                v-else-if="scope.row.status === 'delivery'"
                type="warning"
                effect="dark"
              >Dalam Pengiriman</el-tag>
              <el-tag v-else-if="scope.row.status === 'done'" type="success" effect="dark">Selesai</el-tag>
            </template>
          </el-table-column>
          <el-table-column sortable prop="customerName" label="Customer Name" width="180"></el-table-column>
          <el-table-column sortable prop="customerId" label="Customer ID" width="140"></el-table-column>
          <el-table-column sortable prop="paymentMethod" label="Payment Method" width="180"></el-table-column>
          <el-table-column sortable prop="totalValue" label="Total Value" width="180"></el-table-column>
          <el-table-column
            v-if="branch === 'staging'"
            sortable
            prop="paymentStatus"
            align="center"
            label="Status Payment"
            width="180"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.paymentStatus === 'waiting_for_approval'"
                effect="dark"
              >Menunggu Persetujuan</el-tag>
              <el-tag
                v-if="scope.row.paymentStatus === 'on_progress'"
                effect="dark"
              >On Progress</el-tag>
              <el-tag
                v-else-if="scope.row.paymentStatus === 'done'"
                type="success"
                effect="dark"
              >Selesai</el-tag>
              <div v-else-if="scope.row.paymentStatus === '-'">-</div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" align="center" label="Operations" width="100">
            <template slot-scope="scope">
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-edit"
                circle
                @click="$router.push(`/order/edit/${scope.row.oracleCustomerId}/${scope.row.orderId}`)"
              ></el-button>
            </template>
          </el-table-column>
          <el-table-column sortable label="Created/Updated at" width="180">
            <template slot-scope="scope">
              {{ scope.row.created }}/
              <br />
              {{ scope.row.updated }}
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
          <el-pagination
            layout="prev, pager, next"
            :total="orders.count"
            :current-page="parseInt(page)"
            @current-change="
            e => {
              toAnotherPage(e, optionView, form.search, valueStatus), settingTable(e, optionView);
            }
          "
            :page-size="parseInt(optionView)"
          ></el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      id: null,
      modeShow: false,
      form: {
        search: ""
      },
      optionsView: [
        {
          value: 25,
          label: "25"
        },
        {
          value: 50,
          label: "50"
        },
        {
          value: 75,
          label: "75"
        },
        {
          value: 100,
          label: "100"
        },
        {
          value: 125,
          label: "125"
        },
        {
          value: 150,
          label: "150"
        }
      ],
      optionView: 25,
      optionsStatus: [
        {
          value: 'done',
          label: "Done"
        },
        {
          value: 'on_progress',
          label: "On Progress"
        },
        {
          value: 'payment_confirmation',
          label: "Menunggu Pembayaran"
        },
        {
          value: 'pending',
          label: "Tertunda"
        },
        {
          value: 'delivery',
          label: "Dalam Pengiriman"
        },
      ],
      valueStatus: 'on_progress',
      page: 1,
      branch: 'development'
    };
  },
  mounted() {
   },
  methods: {
    ...mapActions({
      getOrders: "order/GetOrders",
      deleteOrder: "order/DeleteOrder"
    }),
    showDialog(id) {
      (this.id = id), (this.dialog = true);
    },
    toAnotherPage(page, limit, search, status) {
      this.$router.push({ path: "/order", query: { page: page, limit: limit, search: search, status: status } });
    },
    onFilterStatus() {
      this.$router.replace({ path: "/order", query: { page: 1, limit: 25, status: this.valueStatus, search: this.form.search } });
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      this.form.search = this.$router.history.current.query.search || '';
      this.valueStatus = this.$router.history.current.query.status;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search,
        }
      };

      if (this.valueStatus !== '') {
        option = {
          params: {
            ...option.params,
            where: {
              orderStatus: this.valueStatus
            }
          }
        }
      }
      this.getOrders(option);
    },
    onSearch() {
      this.$router.replace({ path: "/order", query: { page: 1, limit: 25, status: this.valueStatus, search: this.form.search } });
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search
        }
      };
      this.getOrders(option);
    },
    settingTable() {
      this.page = this.$router.history.current.query.page;
      this.optionView = this.$router.history.current.query.limit;
      this.form.search = this.$router.history.current.query.search;
      this.valueStatus = this.$router.history.current.query.status;
      let option = {
        params: {
          page: this.page,
          limit: this.optionView,
          search: this.form.search,
        }
      };
      if (this.valueStatus !== '') {
        option = {
          params: {
            ...option.params,
            where: {
              orderStatus: this.valueStatus
            }
          }
        }
      }
      this.getOrders(option);
    }
  },
  computed: {
    ...mapState({
      orders: state => state.order.orders
    })
  },
  created() {
    this.page = this.$router.history.current.query.page || 1;
    this.optionView = this.$router.history.current.query.limit || 25;
    this.form.search = this.$router.history.current.query.search || '';
    this.valueStatus = this.$router.history.current.query.status || '';
    let option = {
      params: {
        page: this.page,
        limit: this.optionView,
        search: this.form.search,
      }
    };
    if (this.valueStatus !== '') {
      option = {
        params: {
          ...option.params,
          where: {
            orderStatus: this.valueStatus
          }
        }
      }
    }
    this.getOrders(option);
    this.branch = process.env.VUE_APP_BRANCH
  }
};
</script>

<style>
.custom-container {
  padding-top: 0px !important;
}
.custom-table thead {
  background-color: #dee2e6;
}
.custom-table thead tr th {
  font-weight: bold;
}
.custom-table tbody {
  background-color: #f8f9fa;
}
</style>
